"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evolvePath = void 0;
const get_length_1 = require("./get-length");
/**
 * @description Animates an SVG from being invisible to it's full length.
 * @param {string} path A valid SVG path
 * @param {number} progress The first valid SVG path
 * @see [Documentation](https://remotion.dev/docs/paths/evolve-path)
 */
const evolvePath = (progress, path) => {
    const length = (0, get_length_1.getLength)(path);
    const strokeDasharray = `${length} ${length}`;
    const strokeDashoffset = length - progress * length;
    return { strokeDasharray, strokeDashoffset };
};
exports.evolvePath = evolvePath;
